import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import Footer from '../common/Footer';
import PricingContent from '../components/pricing/PricingContent';
import Navbar from '../common/Navbar';
import { Helmet } from "react-helmet";

const Pricing = () => {
  const location = useLocation();
  useEffect(() => {
    const { search } = location;
    if (!search) {
      window.scroll(0, 0);
    }
  }, []);
  return (
    <>
      <Helmet>
        <meta
          name="keywords"
          content="services for digital marketing,
                  need digital marketing,
                  full service digital marketing agencies,
                  digital marketing solutions,
                  digital marketing service provider,
                  digital marketing service packages,
                  services for digital marketing,
                  digital marketing price details,
                  Affordable Digital Services,
                  Digital Marketing Pricing & Plans,
                  Digital Marketing Cost in India,
                  whatsapp pricing,
                  marketing solutions for shops Chennai,
                  marketing solutions for shops India"
        />
        <title>Pricing Plans | Affordable Digital Marketing Solutions</title>
        <meta
          name="description"
          content="Explore flexible pricing plans for digital marketing services, SMS campaigns, and WhatsApp marketing designed for measurable business growth."
        />
      </Helmet>

      <Navbar />
      <PricingContent />
      <Footer />
    </>
  )
}

export default Pricing
